'use client'

import React from 'react'

import { CheckboxInput, CheckboxInputProps } from './CheckboxInput'
import { Label, LabelInner } from './styles'

export interface CheckboxProps extends CheckboxInputProps {
  /**
   * Class name
   */
  className?: string

  /**
   * Checkbox label
   */
  label: React.ReactNode

  /**
   * Checkbox name
   */
  name?: string
}

export const Checkbox = React.forwardRef(
  (
    { id, className, label, disabled, size = 'large', ...props }: CheckboxProps,
    ref: React.ForwardedRef<HTMLInputElement>,
  ) => {
    const autoId = React.useId()
    const inputId = id ?? autoId

    const checkbox = (
      <CheckboxInput
        id={inputId}
        ref={ref}
        disabled={disabled}
        size={size}
        {...props}
      />
    )

    if (!label) return checkbox

    return (
      <Label className={className} htmlFor={inputId} disabled={disabled}>
        {checkbox}
        <LabelInner size={size} disabled={disabled}>
          {label}
        </LabelInner>
      </Label>
    )
  },
)

Checkbox.displayName = 'Checkbox'
